import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {Button, Form, Col, Row, Table, OverlayTrigger, Popover} from 'react-bootstrap';
import {registerLocale} from 'react-datepicker';
import CommonMetaTag from './common-meta-tag';
import 'react-datepicker/dist/react-datepicker.css';
import {useTranslation} from 'react-i18next';
import it from 'date-fns/locale/it';
import {enableDisableNotifications} from '../actions/admin';
registerLocale('it', it);

const AdminNvrDashboard = ({nvrStatus, enableDisableNotifications}) => {
  const {t} = useTranslation();

  const popover = errorMessage => (
    <Popover>
      <Popover.Title>{t('ERROR')}</Popover.Title>
      <Popover.Content>
        {errorMessage}
      </Popover.Content>
    </Popover>
  );

  return (
    <Fragment>
        <CommonMetaTag/>
        <div style={{marginTop: 100, marginLeft: 20, marginRight:20}}>
            <Row className="justify-content-center" style={{marginTop: 20, marginBottom: 20}}>
                <Col xs={12} sm={12} md={8}>
                    <Table hover responsive>
                        <thead>
                            <tr>
                                <th className="text-center">{t('STATE')}</th>
                                <th className="text-center">{t('FIELD')}</th>
                                <th className="text-center">{t('ANOMALY')}</th>
                                <th className="text-center">{t('ANOMALY_START')}</th>
                                <th className="text-center">{t('NOTIFICATIONS')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {nvrStatus.map(n => (
                                <tr key={n.id}>
                                    <td className="col-md-1 text-center">
                                        {n.nvrOk? 
                                        <span className="badge bg-success">OK</span>
                                        : <span className="badge bg-danger">KO</span>}
                                    </td>
                                    <td className="col-md-6 text-center">{n.fieldId + ' ' + n.fieldName + ' - ' + n.partnerName}</td>
                                    <td className="col-md-1 text-center">
                                        {n.errorMessage ?
                                        <OverlayTrigger trigger="click" placement="top" overlay={popover(n.errorMessage)}>
                                            <Button variant="secondary">{t('ERROR')}</Button>
                                        </OverlayTrigger>
                                        : null}
                                    </td>
                                    <td className="col-md-3 text-center">
                                        {
                                            n.nvrOk && n.errorMessage ?
                                            <p>{new Date(n.errorDatetime).toLocaleString()}</p>
                                            : !n.nvrOk?
                                            <p>{new Date(n.lastCallDatetime).toLocaleString()}</p>
                                            : null
                                        }
                                    </td>
                                    <td className="col-md-1 text-center">
                                        <Form.Check
                                            id={`switch-${n.id}`}
                                            className={'custom-switch'}
                                            type="switch"
                                            checked={n.notificationsEnabled}
                                            onChange={e => enableDisableNotifications(n.id, e.target.checked)}/>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </div>
    </Fragment>
  );
};

const mapStateToProps = ({admin: {nvrStatus}}) => ({
    nvrStatus
});

const mapDispatchToProps = dispatch => ({
    enableDisableNotifications: (nvrId, checked) => {
        dispatch(enableDisableNotifications(nvrId, checked));
    }
});

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminNvrDashboard));
